module.exports = __webpack_public_path__ + "img/listening.06821f3e.png";